import { NgModule } from '@angular/core';
import { UserDrawerComponent } from './components/user-drawer/user-drawer.component';
import { ConfirmModalComponent } from './components/confirm-modal/confirm-modal.component';
import { IconModule } from "./components/icon/icon.module";
import { AsyncPipe, NgIf, CommonModule } from "@angular/common";
import { NzButtonComponent } from "ng-zorro-antd/button";
import { NzAvatarComponent } from "ng-zorro-antd/avatar";
import { NzCardComponent } from "ng-zorro-antd/card";
import { NzRadioComponent, NzRadioGroupComponent } from "ng-zorro-antd/radio";
import { NzSelectComponent, NzOptionComponent } from "ng-zorro-antd/select";
import { NzDatePickerComponent } from "ng-zorro-antd/date-picker";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { EmptyStateComponent } from './components/empty-state/empty-state.component';
import { ReportFiltersComponent } from './components/report-filters';
import { NzColDirective, NzRowDirective } from "ng-zorro-antd/grid";
import { NzSliderComponent } from "ng-zorro-antd/slider";
import { NzInputDirective, NzInputGroupComponent } from "ng-zorro-antd/input";
import { AuthBasicModalComponent } from './components/auth-basic-modal/auth-basic-modal.component';
import { AuthOauth2ModalComponent } from './components/auth-oauth2-modal/auth-oauth2-modal.component';
import { NzTooltipDirective } from "ng-zorro-antd/tooltip";
import {NzSwitchComponent} from "ng-zorro-antd/switch";
import {NzSegmentedComponent} from "ng-zorro-antd/segmented";

@NgModule({
  declarations: [
    UserDrawerComponent,
    ConfirmModalComponent,
    EmptyStateComponent,
    ReportFiltersComponent,
    AuthBasicModalComponent,
    AuthOauth2ModalComponent
  ],
    imports: [
        CommonModule,
        IconModule,
        NgIf,
        NzButtonComponent,
        NzAvatarComponent,
        AsyncPipe,
        NzCardComponent,
        NzRadioGroupComponent,
        NzRadioComponent,
        NzSelectComponent,
        NzOptionComponent,
        NzDatePickerComponent,
        FormsModule,
        ReactiveFormsModule,
        NzColDirective,
        NzRowDirective,
        NzSliderComponent,
        NzInputDirective,
        NzInputGroupComponent,
        NzTooltipDirective,
        NzSwitchComponent,
        NzSegmentedComponent
    ],
  exports: [
    UserDrawerComponent,
    ConfirmModalComponent,
    EmptyStateComponent,
    ReportFiltersComponent,
    AuthBasicModalComponent,
    AuthOauth2ModalComponent
  ],
})
export class SharedComponentsModule { }
